import React, { FC } from 'react';
import { Popover as MPopover } from '@mantine/core';
import classNames from 'classnames';

import styles from './styles.module.scss';
import { FloatingPosition } from '@mantine/core/lib/Floating';

interface Props {
  className?: string;
  position?: FloatingPosition;
  target?: JSX.Element;
  dropdownTarget?: JSX.Element;
  trapFocus?: boolean | undefined;
  dropdownWidth?: number;
}

const Popover: FC<Props> = ({ className, position = 'bottom', trapFocus, target, dropdownTarget, dropdownWidth }) => {
  return (
    <MPopover width={dropdownWidth} position={position} trapFocus={trapFocus}>
      <MPopover.Target>{target}</MPopover.Target>
      <MPopover.Dropdown className={classNames(styles['popover'], className)}>{dropdownTarget}</MPopover.Dropdown>
    </MPopover>
  );
};

export default Popover;
